// extracted by mini-css-extract-plugin
export default {"Text":"_2dBdQ","text-card-textarea":"QBAWN","text-card-markdown":"dEs6g","single-row":"_2UwlZ","padded":"_3iN6k"};